export default "__VITE_ASSET__Dg6Ot$OQ__"